import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RowDef } from '../../../shared/components/table/table.component';
import { AppscriptsSmsFilter } from '../../../shared/models/appscripts-sms.model';
import { ModalService } from '../../../shared/services/modal.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { AppscriptsMoSmsFilterComponent } from '../appscripts-mo-sms-filter/appscripts-mo-sms-filter.component';
import { AppscriptsMoSmsTableComponent } from '../appscripts-mo-sms-table/appscripts-mo-sms-table.component';

@Component({
  standalone: false,
  selector: 'appscripts-mo-sms-index',
  templateUrl: 'appscripts-mo-sms-index.component.html',
})
export class AppscriptsMoSmsIndexComponent implements AfterViewInit {
  @ViewChild('copyPhonesModalTpl', { read: TemplateRef, static: false }) copyPhonesModalTpl: any;
  copyPhonesText: string;
  copyPhonesTextControlRows: number;

  @ViewChild(AppscriptsMoSmsFilterComponent, { static: false }) filter: AppscriptsMoSmsFilterComponent;
  @ViewChild(AppscriptsMoSmsTableComponent, { static: false }) table: AppscriptsMoSmsTableComponent;

  backButtonShow = false;

  selectedRows: RowDef[] = [];
  batchCompleted = 0;
  progressShow = false;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    public notificationService: NotificationService,
    private titleService: Title,
    public modal: ModalService
  ) {
    titleService.setTitle('MO SMS');
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      if (params.phonenumber) {
        this.filter.model.phoneNumbers = params.phonenumber;
        this.backButtonShow = true;
      }
      const phoneNumberFilter = this.filter.filters.find(f => f.title === 'Phone');
      this.filter.onChangeFilterValue(this.filter.model.phoneNumbers, phoneNumberFilter, true);
    });
  }

  onFilter(data) {
    const params: AppscriptsSmsFilter = {};
    if (data.receivedAtFrom && data.receivedAtTo) {
      params.receivedAtFrom = data.receivedAtFrom;
      params.receivedAtTo = data.receivedAtTo;
    }
    if (data.createdAtFrom && data.createdAtTo) {
      params.createdAtFrom = data.createdAtFrom;
      params.createdAtTo = data.createdAtTo;
    }

    const rawSearchFields = ['text', 'phoneNumbers', 'destination', 'moId', 'telqId'];
    rawSearchFields.map(field => {
      const v = data[field];
      if (v === '' || v === null || v === undefined) {
        return;
      }
      params[field] = v;
    });

    this.table.filter = params;
    this.table.page = 1;
    this.table.update();
  }

  onClickCopyPhones() {
    const phones = this.selectedRows.map(_ => _.data.phoneNumber);
    this.copyPhonesText = phones.join('\n');
    this.copyPhonesTextControlRows = phones.length;
    this.modal.alert().component(this.copyPhonesModalTpl).open();
  }

  onClickCopyPhonesControl(e) {
    const input = e.target;
    if (input.setSelectionRange) {
      input.setSelectionRange(0, input.value.length);
    } else {
      input.select();
    }
  }

  batchClear() {
    this.progressShow = false;
    this.selectedRows = [];
    this.table.resetBatch();
  }
}
